import NumberBox, { NumberBoxTypes } from "devextreme-react/cjs/number-box";
import { useEffect, useState } from "react";

interface NumberBoxWrapperProps {
  value: number;
  min?: number;
  max?: number;
  width?: number;
  onCommit: (value: number) => void;
}

export default function NumberBoxWrapper({
  value,
  min = 0,
  max,
  width,
  onCommit,
}: NumberBoxWrapperProps) {
  const [localValue, setLocalValue] = useState<number>(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  return (
    <NumberBox
      value={localValue}
      min={min}
      max={max}
      width={width}
      showSpinButtons
      showClearButton
      onValueChanged={(e: NumberBoxTypes.ValueChangedEvent) => {
        setLocalValue(e.value ?? 0);
        if (e.event?.type === "blur") {
          onCommit(e.value ?? 0);
        }
      }}
    />
  );
}